import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpInterceptor, HttpParams} from '@angular/common/http';

@Injectable()
export class DevAuthInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler) {
        console.log('HUIIII', request);
        const params = new HttpParams({
            fromString: 'ng_token=123'
        });
        request = request.clone({
            params: params
        });
        return next.handle(request);
    }
}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/interceptors/dev-auth.interceptor.ts